import { cn } from "@/lib/utils";
import {
  KPIStrip,
  KPIStripItem,
  KPIStripItemLabel,
  KPIStripItemValue,
} from "@/components/ui/kpi-strip";
import type { ProductionOrder } from "../../types/production-orders.types.js";

// Strip de KPIs acima da timeline (artboard 01 do protótipo).
export function OpTimelineKpis({
  items,
  conflicts,
}: {
  items: ProductionOrder[];
  conflicts: number;
}) {
  const scheduled = items.filter((o) => o.status === "SCHEDULED").length;
  const runningLines = new Set(items.filter((o) => o.status === "RUNNING").map((o) => o.lineId))
    .size;
  const cancelled = items.filter((o) => o.status === "CANCELLED").length;

  return (
    <KPIStrip>
      <KPIStripItem>
        <KPIStripItemLabel>Agendadas</KPIStripItemLabel>
        <KPIStripItemValue className="text-brand-600">{scheduled}</KPIStripItemValue>
        <span className="text-[11px] text-text-tertiary">no período</span>
      </KPIStripItem>
      <KPIStripItem>
        <KPIStripItemLabel>Em execução</KPIStripItemLabel>
        <KPIStripItemValue className="text-rd-success-700">{runningLines}</KPIStripItemValue>
        <span className="text-[11px] text-text-tertiary">linhas ativas</span>
      </KPIStripItem>
      <KPIStripItem>
        <KPIStripItemLabel>Canceladas</KPIStripItemLabel>
        <KPIStripItemValue className="text-rd-danger-700">{cancelled}</KPIStripItemValue>
        <span className="text-[11px] text-text-tertiary">no período</span>
      </KPIStripItem>
      <KPIStripItem>
        <KPIStripItemLabel>Conflito de janela</KPIStripItemLabel>
        <KPIStripItemValue className={cn(conflicts > 0 && "text-rd-warning-700")}>
          {conflicts}
        </KPIStripItemValue>
        <span className="text-[11px] text-text-tertiary">
          {conflicts > 0 ? "requer ação" : "ok"}
        </span>
      </KPIStripItem>
      <KPIStripItem>
        <KPIStripItemLabel>Total no período</KPIStripItemLabel>
        <KPIStripItemValue>{items.length}</KPIStripItemValue>
        <span className="text-[11px] text-text-tertiary">ordens</span>
      </KPIStripItem>
    </KPIStrip>
  );
}
